







































import Vue from 'vue';

import BusinessHome from '@/components/BusinessHome.vue';

export default Vue.extend({
  
  data: () => ({
    
    homeicon:'',
    hometitle:'',
    eventicon:'',
    eventtitle:'',
    teamtitle:'',
    teamicon:'',
    lovetitle:'',
    loveicon:'',
    activeBtn: 0,
  }),
  components: {
    BusinessHome,
  },
  created()
  {
    this.hometitle='Home';
    this.homeicon='mdi-home';
    this.eventtitle='Food';
    this.eventicon='mdi-food';
    this.teamtitle='Team';
    this.teamicon='mdi-account-multiple';
    this.lovetitle='Love';
    this.loveicon='mdi-share-variant';
  },
  methods:{
    home()
    {
       
      //this.$router.push({name:'bDetails'});
      //this.$router.push({name:'coronasurvey'});
      //this.activeBtn=0;
      //this.currentSection='overview';
    },
  }
})
